// extracted by mini-css-extract-plugin
export var border = "TextAndImageCardSquare-module--border--ca202";
export var bordercontainer = "TextAndImageCardSquare-module--bordercontainer--1046f";
export var buttonwrapper = "TextAndImageCardSquare-module--buttonwrapper--03155";
export var details = "TextAndImageCardSquare-module--details--0b421";
export var image = "TextAndImageCardSquare-module--image--3d9bf";
export var text = "TextAndImageCardSquare-module--text--23634";
export var textandimagecardcontainer = "TextAndImageCardSquare-module--textandimagecardcontainer--a6965";
export var title = "TextAndImageCardSquare-module--title--890dd";